import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useTranslation } from "react-i18next";
import Copy from "../Copy";
import Box from "../Box";
import { Main, Wrapper } from "../Layout";
import { getIsWebView } from "../../utils/webView";

const SSOLogout = () => {
  const { t } = useTranslation();
  const { instance, inProgress } = useMsal();
  const queryStringParams = getIsWebView() ? "?webview=1" : "";

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      const options = {
        postLogoutRedirectUri: "/player/logout" + queryStringParams,
      };
      instance.logoutRedirect(options);
    }
  }, [instance, inProgress, queryStringParams]);

  return (
    <Wrapper>
      <Main isWide={true}>
        <Box mb={4}>
          <Copy>
            <p>{t("logout.signOutText", "Signing you out...")}</p>
          </Copy>
        </Box>
      </Main>
    </Wrapper>
  );
};

export default SSOLogout;
